export const isMobile = () => /Mobi/i.test(window.navigator.userAgent)
